import { useParams } from "react-router";
import ReviewWorkspace from "./ReviewWorkspace";

/**
 * `/reviews/<change set>?unit=<unit key>`: an old review address, and the link module B's
 * notices give (ADR-0031 D4). It hands over to the Thread step that decides the change set;
 * one made outside any Workflow is reviewed here until ensured review Threads exist.
 */
export default function ReviewPage() {
  const { changeSetId = "" } = useParams();
  return <ReviewWorkspace changeSetId={changeSetId} place={{ kind: "address" }} />;
}
